import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/views/frame/mainpage'
import Home from '@/views/home/index'
import NOPermission from '@/views/home/nopermission'

//订单管理
import Order from '@/views/order/order'
import NewOrder from '@/views/order/neworder'
import CheckOrder from '@/views/order/checkorder'
import EditOrder from '@/views/order/editorder'
// 在库订单
import Instock from '@/views/instock/instock'

//订单操作
import Orderoperation from '@/views/orderOperation/orderoperation'
import SeparateQuote from '@/views/orderOperation/separatequote'
import Pickupgoods from '@/views/orderOperation/pickupgoods'
import Arrivalgoods from '@/views/orderOperation/arrivalgoods'
import Claimlist from '@/views/orderOperation/claimlist'
import Measuregoods from '@/views/orderOperation/measuregoods'
import MeasureEdit from '@/views/orderOperation/measureedit'
import Checkgoods from '@/views/orderOperation/checkgoods'
import Shelvesgoods from '@/views/orderOperation/shelvesgoods'
import CapacityAllocation from '@/views/orderOperation/capacityallocation'
import BatchOperation from '@/views/orderOperation/batchoperation'
import EditBatchOperation from '@/views/orderOperation/EditBatchOperation'
import GoodsToSend from '@/views/orderOperation/goodstosend'
import LastMileExpress from '@/views/orderOperation/lastmileexpress'
import TransferNumber from '@/views/orderOperation/transfernumber'

import OrderCharge from '@/views/orderOperation/ordercharge'
import AbnormalCharge from '@/views/orderOperation/abnormalcharge'
import ChargeSupplement from '@/views/orderOperation/chargesupplement'
import NewCostBack from '@/views/orderOperation/newcostback'
import DriverPickUp from '@/views/orderOperation/driverpickup'
import PhonePickUp from '@/views/orderOperation/phonepickup'
import BatchCostManage from '@/views/orderOperation/batchcostmanage'
import BatchChargeException from '@/views/orderOperation/batchchargeexception'
import supplierorder from '@/views/orderOperation/supplierorder'

// 保险订单
import insuranceorder from '@/views/orderOperation/insuranceorder'


// 提成费用
import Commission from '@/views/orderOperation/commission'

// 提成费用异常
import CommissionException from '@/views/orderOperation/commission_exception'

// 预警
import Alarm from '@/views/alarm/alarm'
import AlarmOrder from '@/views/alarm/alarm_order'
import AlarmBatch from '@/views/alarm/alarm_batch'
import AlarmAmount from '@/views/alarm/alarm_amount'



//系统设置
import System from '@/views/system/system'
import CapacityManagement from '@/views/system/capacity'
import SupplierManagement from '@/views/system/supplier'
import ChannelSettings from '@/views/system/channel'
import VehicleManagement from '@/views/system/vehicle'
import DriverManagement from '@/views/system/driver'
import CustomsClearance from '@/views/system/customsclearance'
import fbaAddress from '@/views/system/fbaaddress'
import Sorting from '@/views/system/sorting'
import SingleCarton from '@/views/system/singlecarton'
import ChargeSubject from '@/views/system/chargesubject'
import Bulletin from '@/views/system/bulletin'
import ServiceTypeManage from '@/views/system/servicetypemanage'
import SupplierChannel from '@/views/system/supplierchannel'
import ExchangeRate from '@/views/system/exchange_rate'
import Company from '@/views/system/company'

//客户管理
import Customer from '@/views/customer/customer'
import CustomerList from '@/views/customer/customerlist'
import NewCustomer from '@/views/customer/newcustomer'
import ProductPrice from '@/views/customer/productprice'
import NewPrice from '@/views/customer/newprice'

//用户管理
import User from '@/views/user/user'
import Staff from '@/views/user/staff'
import Jurisdiction from '@/views/user/jurisdiction'
import OrgPage from '@/views/user/orgPage'

//仓库管理
import WarehouseView from '@/views/warehouse/warehouseview'
import Warehouse from '@/views/warehouse/warehouse'
import NewWarehouse from '@/views/warehouse/NewWarehouse'
import Area from '@/views/warehouse/area'

// 单独供财务系统查询交易流水详情
import TransactionDetail from '@/views/transactionDetail/detail'

/** 报表 **/
import Report from '../views/report/report'
import ReportCustomer from '../views/report/customer'
import ReportChannel from '../views/report/channel'
import ReportSalesman from '../views/report/salesman'
import ReportBatch from '../views/report/batch'
import ReportSupplier from '../views/report/supplier'
import ReportOrder from '../views/report/order'
import ReportSalemansGoal from '../views/report/salesman_goal'

/** 财务款项 **/
import Account from '@/views/account/account'
import Reconciliation from '@/views/account/reconciliation'
import supplierInvoice from '@/views/account/supplier_invoice'
import Mothreport from '@/views/account/mothreport'



// 系统公告
import Bulletins from '@/views/usercenter/bulletin'

// 最新消息
import Message from '@/views/usercenter/message'

import SystemInfo from '@/views/usercenter/systeminfo'

// 更新报价
import Quotation from '@/views/usercenter/quotation'
import RemoteZipcode from '@/views/system/remote_zipcode'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: '/',
      component: MainPage,
      children: [{
          path: '/',
          name: '首页',
          component: Home
        },{
          path: '/login',
          component: () => import('@/views/login/index'),
          hidden: true
        },
        {
          path: '/nopermission',
          name: '无权限页面',
          component: NOPermission
        },
        {
          path: '/order',
          name: '订单管理',
          component: Order
        },
        {
          path: '/in-stock',
          name: '在库订单',
          component: Instock
        },
        {
          path: '/neworder',
          name: '新建订单',
          component: NewOrder
        },
        {
          path: '/checkorder',
          name: '查看订单',
          component: CheckOrder
        },
        {
          path: '/editorder',
          name: '编辑订单',
          component: EditOrder
        },
        {
          path: '/warehouse',
          name: '仓库管理',
          component: WarehouseView,
          children: [{
              path: 'warehouse',
              name: '仓库',
              component: Warehouse
            },
            {
              path: 'warehouse/new',
              name: 'NewWarehouse',
              component: NewWarehouse
            },
            {
              path: 'area',
              name: '区域',
              component: Area
            },
          ]
        },
        {
          path: '/orderoperation',
          name: '订单操作',
          component: Orderoperation,
          children: [
            {
                path: 'separate-quote',
                name: '单独报价订单',
                component: SeparateQuote
              },
            {
              path: 'pickupgoods',
              name: '提货订单',
              component: Pickupgoods
            },
            {
              path: 'arrivalgoods',
              name: '到货订单',
              component: Arrivalgoods
            },
            {
              path: 'claimlist',
              name: '认领列表',
              component: Claimlist
            },
            {
              path: 'measuregoods',
              name: '货物测量',
              component: Measuregoods
            },
            {
              path: 'measureedit',
              name: '修改测量数据',
              component: MeasureEdit
            },
            {
              path: 'checkgoods',
              name: '仓库查货',
              component: Checkgoods
            },
            {
              path: 'shelvesgoods',
              name: '货物上架',
              component: Shelvesgoods
            },
            {
              path: 'capacityallocation',
              name: '运力分配',
              component: CapacityAllocation
            },
            {
              path: 'batchoperation',
              name: '批次操作',
              component: BatchOperation
            },
            {
              path: 'batchoperation/edit',
              name: 'EditBatchOperation',
              component: EditBatchOperation
            },
            {
              path: 'goodstosend',
              name: '货物派送',
              component: GoodsToSend
            },
            {
              path: 'lastmileexpress',
              name: '尾程面单打印',
              component: LastMileExpress
            },
            {
              path: 'transfernumber',
              name: '转单',
              component: TransferNumber
            },
            {
              path: 'ordercharge',
              name: '订单费用',
              component: OrderCharge
            },
            {
              path: 'chargesupplement',
              name: '费用补录',
              component: ChargeSupplement
            },
            {
              path: 'newcostback',
              name: '新建费用补录',
              component: NewCostBack
            },
            {
              path: 'abnormalcharge',
              name: '订单费用异常',
              component: AbnormalCharge
            },
            {
              path: 'driverpickup',
              name: '司机提货',
              component: DriverPickUp
            },
            {
              path: 'batchcostmanage',
              name: '批次成本管理',
              component: BatchCostManage
            },
            {
              path: 'batchchargeexception',
              name: '批次费用异常',
              component: BatchChargeException
            },
              {
              path: 'supplierorder',
              name: '供应商订单',
              component: supplierorder
            },
            {
              path: 'insurance-order',
              name: '保险订单',
              component: insuranceorder
            },
            {
              path: 'commission',
              name: '提成费用',
              component: Commission
            },
            {
              path: 'commission-exception',
              name: '提成费用异常',
              component: CommissionException
            }
          ]
        },
        {
          path: '/customer',
          name: '客户管理',
          component: Customer,
          children: [{
              path: 'customerlist',
              name: '客户列表',
              component: CustomerList
            },
            {
              path: 'newcustomer',
              name: '新建客户',
              component: NewCustomer
            },
            {
              path: 'productprice',
              name: '产品价格',
              component: ProductPrice
            },
            {
              path: 'newprice',
              name: '新建价格',
              component: NewPrice
            }
          ]
        },
        {
          path: '/system',
          name: '系统管理',
          component: System,
          children: [{
              path: 'capacitymanagement',
              name: '运力资源管理',
              component: CapacityManagement
            },
            {
              path: 'suppliermanagement',
              name: '供应商管理',
              component: SupplierManagement
            },
            {
              path: 'channelsettings',
              name: '渠道设置',
              component: ChannelSettings
            },
            {
              path: 'vehiclemanagement',
              name: '车辆管理',
              component: VehicleManagement
            },
            {
              path: 'drivermanagement',
              name: '司机管理',
              component: DriverManagement
            },
            {
              path: 'customsclearance',
              name: '报关行&清关行',
              component: CustomsClearance
            },
            {
              path: 'fbaaddress',
              name: 'FBA地址',
              component: fbaAddress
            },
            {
              path: 'sorting',
              name: '分拣管理',
              component: Sorting
            },
            {
              path: 'singlecarton',
              name: '箱面单管理',
              component: SingleCarton
            },
            {
              path: 'chargesubject',
              name: '费用科目',
              component: ChargeSubject
            },
            {
              path: 'bulletin',
              name: '公告',
              component: Bulletin
            },
            {
              path: 'servicetypemanage',
              name: '服务类型管理',
              component: ServiceTypeManage
            },
            {
              path: 'supplierchannel',
              name: '供应商渠道管理',
              component: SupplierChannel
            },
            {
              path: 'exchangerate',
              name: '汇率管理',
              component: ExchangeRate
            },
            {
              path: 'company',
              name: '分公司管理',
              component: Company
            },
            {
              path: 'remote-zipcode',
              name: '偏远邮编查询',
              component: RemoteZipcode
            }
          ]
        },
        {
          path: '/user',
          name: '用户管理',
          component: User,
          children: [{
              path: 'staff',
              name: '内部员工',
              component: Staff
            },
            {
              path: 'jurisdiction',
              name: '权限分配',
              component: Jurisdiction
            },
            {
              path: 'org',
              name: '组织架构',
              component: OrgPage
            },
          ]
        },
        {
            path: '/report',
            name: 'report',
            component: Report,
            children: [{
                    path: 'customer',
                    name: 'report.customer',
                    component: ReportCustomer
                },
                {
                    path: 'channel',
                    name: 'report.channel',
                    component: ReportChannel
                },
                {
                    path: 'salesman',
                    name: 'report.salesman',
                    component: ReportSalesman
                },
                {
                    path: 'batch',
                    name: 'report.batch',
                    component: ReportBatch
                },
                {
                    path: 'supplier',
                    name: 'report.supplier',
                    component: ReportSupplier
                },
                {
                    path: 'order',
                    name: 'report.order',
                    component: ReportOrder
                },
                {
                    path: 'salemans-goal',
                    name: 'report.salemans-goal',
                    component: ReportSalemansGoal
                }
            ]
            
        },
        {
          path: '/account',
          name: '财务款项',
          component: Account,
          children: [{
              path: 'reconciliation',
              name: '财务对账',
              component: Reconciliation
            },
            {
              path: 'supplier-invoice',
              name: '供应商账单',
              component: supplierInvoice
            },
            {
              path: 'month',
              name: '月报表',
              component: Mothreport
            }
          ]
        },
        {
          path: '/alarm',
          name: '预警',
          component: Alarm,
          children: [{
              path: 'order',
              name: '订单预警',
              component: AlarmOrder
            },
            {
              path: 'batch',
              name: '批次预警',
              component: AlarmBatch
            },
            {
              path: 'amount',
              name: '应收预警',
              component: AlarmAmount
            }
          ]
        },
        {
          path: 'bulletins',
          name: 'bulletins',
          component: Bulletins
        }, {
          path: 'message',
          name: 'message',
          component: Message
        }, {
          path: 'quotation',
          name: 'quotation',
          component: Quotation
        }, {
          path: 'systeminfo',
          name: 'systeminfo',
          component: SystemInfo
        }
      ]
    },
    {
      path: '/phonepickup',
      name: '微信提货',
      component: PhonePickUp
    },
    {
      path: '/detail',
      name: '交易流水详情',
      component: TransactionDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js